import React, { useEffect } from "react"
import SEO from "@components/SEO"
import CorporativeHeader from "@components/global/CorporativeHeader"
import Hero from "@components/RisksIdPage/Hero"
import BodyRisks from "@components/RisksIdPage/BodyRisks"
import { graphql } from "gatsby"
import { constants } from "@constants/constants"
import "@styles/Components/risks.scss"
import CorporativeFooter from "@components/global/CorporativeFooter" 
import RiskAssessment from "@components/global/RiskAssessment"
import Footer from "@components/global/Footer"

const { SANITY_PROJECTID, SANITY_DATASET, SANITY_TOKEN } = constants

const incrementCount = id => {
  const mutations = [
    {
      patch: {
        id,
        setIfMissing: {
          viewCount: 0,
        },
        inc: {
          viewCount: 1,
        },
      },
    },
  ]
  fetch(
    `https://${SANITY_PROJECTID}.api.sanity.io/v1/data/mutate/${SANITY_DATASET}`,
    {
      method: "post",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${SANITY_TOKEN}`,
      },
      body: JSON.stringify({ mutations }),
    }
  )
    .then(response => response.json())
    .catch(err => err)
}

const RiskPage = ({ data: { sanityRisks, allSanityRisks }, path }) => {
  useEffect(() => {
    const viewedPost = localStorage.getItem(`risks${sanityRisks.id}`)
    if (!viewedPost) {
      incrementCount(sanityRisks._id)
      localStorage.setItem(`risks${sanityRisks.id}`, "true")
    }
  })

  const meta = sanityRisks.seo
    ? Object.entries(sanityRisks.seo).map(([key, value]) => {
        return { name: key, content: value }
      })
    : []

  return (
    <>
      <SEO meta={meta} seo={sanityRisks.seo}>
        <title>{sanityRisks.title} / ClimateCheck</title>
      </SEO>

      <CorporativeHeader />
      <Hero post={sanityRisks} slugs={allSanityRisks.nodes} />
      <BodyRisks
        path={path}
        _rawBody={sanityRisks._rawBody}
        slugs={allSanityRisks.nodes}
      />
      <RiskAssessment />
      <Footer />
    </>
  )
}
export default RiskPage

export const query = graphql`
  query RisksQuery($slug: String!) {
    sanityRisks(slug: { current: { eq: $slug } }) {
      id
      _id
      title
      slug {
        current
      }
      customImage {
        image {
          asset {
            gatsbyImageData(placeholder: BLURRED formats:[AUTO, WEBP, AVIF])
            description
          }
        }
      }
      body {
        children {
          text
        }
      }
      _rawBody(resolveReferences: { maxDepth: 5 })
      author {
        name
      }
      categories {
        title
      }
      seo {
        title
        description
        keywords
      }
    }
    allSanityRisks {
      nodes {
        slug {
          current
        }
      }
    }
  }
`
